import { Fragment } from "react";
import "./SolidityDevelopment.css";
import { solidityDevelopment } from "../../staticdata";

const SolidityDevelopment = () => {
  return (
    <Fragment>
      <section className="soliditydevelopment-style">
        <div className="container">
          <div className="soliditydevelopment-services">
            <div className="container">
              <div
                className="section-title"
                data-aos="fade-down"
                data-aos-duration="800"
              >
                <h1 className="text-center">
                  <span className="title-gradient">Solidity</span> Development
                </h1>
                <p className="text-center">
                  Easily create sturdy smart contracts powered by decentralized
                  apps with our Solidity development services. Solidity
                  programming language helps unlock innovations across several
                  new verticals of the web 3.0 ecosystem. With the help of
                  Solidity, impeccable smart contracts and blockchain can be
                  developed that are highly functional.
                </p>
              </div>
              <div className="row gy-4">
                {solidityDevelopment.map((services, index) => (
                  <div
                    className="col-md-6 d-flex"
                    key={services.id}
                    data-aos="zoom-in"
                    data-aos-delay={index * 100}
                  >
                    <div
                      className="service-item-premium 
                                d-flex flex-column 
                                flex-lg-row flex-md-row 
                                align-items-center 
                                align-items-lg-start 
                                align-items-md-start 
                                gap-3 p-4 w-100"
                    >
                      <div className="icon-ring-premium">
                        <img
                          src={services.icon}
                          alt="img not found"
                          style={{ width: "45px", height: "45px" }}
                        />
                      </div>
                      <div className="service-item-desc">
                        <h5 className="mb-1">{services.title}</h5>
                        <p className="text-light mb-0">
                          {services.description}
                        </p>    
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default SolidityDevelopment;
